import { AppCrumbs } from './AppCrumbs';

export default AppCrumbs;
